import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { auth } from '../../../../services';
import { Input } from 'reactstrap';
import { DropDownList } from '@progress/kendo-react-dropdowns';

class OrganizationInviteUser extends Component {
	constructor(props) {
		super(props);
		this.state = {
      userInEdit: {
        Email:this.props.email,
        mailingStateId: 44,
        firstName:"",
        lastName:"",
        mailingAddress1:"",
        mailingAddress2:"",
        mailingCity:"",
        mailingZip:"",
        phone:"",
        // memberSequenceNum: 1,
        state: {
          id: 0,
          name: ""
        }
      }
		};	
  }

  componentDidMount() {
    if (this.props.initUser) {
      this.props.initUser(this.state.userInEdit);
    }
  }
	
	onDialogInputChange = (event) => {
    let target = event.target;
		const value = target.value;
		const name = target.props ? target.props.name : target.name;

		const edited = this.state.userInEdit;
		edited[name] = value;
		this.setState({
			organizationInEdit: edited,
    }, () => {
      this.props.inviteUserStateChange(this.state.userInEdit);
    });
  }

  handleState = (event) => {
    let target = event.target;
		const value = target.value;
		const name = target.props ? target.props.name : target.name;
		
		const edited = this.state.userInEdit;
		edited.state.name = event.target.value.name;
		edited.state.id = event.target.value.id;

		this.setState({
			userInEdit: edited
    }, () => {
      this.props.inviteUserStateChange(this.state.userInEdit);
    });
  }

  handleZipChange = (event) => {
		var originalValue = this.state.userInEdit.mailingZip;
		const edited = this.state.userInEdit;
		var value = event.target.value.replace(/\D/g, '');;
		if ((value.match(/^[0-99999]|^$/) || value == "") && value.length <= 5) {
			edited.mailingZip = value;
			this.setState({
				userInEdit: edited
			}, () => {
        this.props.inviteUserStateChange(this.state.userInEdit);
      });
		}
		else {
			edited.mailingZip = originalValue;
			this.setState({
				userInEdit: edited
			}, () => {
        this.props.inviteUserStateChange(this.state.userInEdit);
      });
		}
  }

  formatPhone = (val) => {
    if (!val) return val;
    var x = val.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
  }

  handlePhoneChange = (event) => {
    const value = this.formatPhone(event.target.value);
    const edited = this.state.userInEdit;
    edited.phone = value;
    this.setState({
      userInEdit: edited
    }, () => {
      this.props.inviteUserStateChange(this.state.userInEdit);
    });
  }
  
  handleBlur = (field) => (evt) => {
    this.props.handleBlur(field);
  }

	render() {
    return (
      <div className="invite-new-user d-block">
        <div className="row">
          <div className="form-group col-md-6">
            <label htmlFor="firstName"
              className={this.props.touched.firstName && this.state.userInEdit.firstName === '' ? "error" : ""}
            >First Name</label>
            <Input
              type="firstName"
              name="firstName"
              id="firstName"
              onChange={this.onDialogInputChange}
              value={this.state.userInEdit.firstName}
              onBlur={this.handleBlur('firstName')}
              invalid={this.props.touched.firstName && this.state.userInEdit.firstName === '' ? true : false}
            />
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="lastName"
              className={this.props.touched.lastName && this.state.userInEdit.lastName === '' ? "error" : ""}
            >Last Name</label>
            <Input
              type="lastName"
              name="lastName"
              id="lastName"
              onChange={this.onDialogInputChange}
              value={this.state.userInEdit.lastName}
              onBlur={this.handleBlur('lastName')}
              invalid={this.props.touched.lastName && this.state.userInEdit.lastName === '' ? true : false}
            />
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-6">
            <label htmlFor="mailingAddress1"
              className={this.props.touched.mailingAddress1 && this.state.userInEdit.mailingAddress1 === '' ? "error" : ""}
            >Address 1</label>
            <Input
              type="text"
              name="mailingAddress1"
              id="mailingAddress1"
              onChange={this.onDialogInputChange}
              value={this.state.userInEdit.mailingAddress1}
              onBlur={this.handleBlur('mailingAddress1')}
              invalid={this.props.touched.mailingAddress1 && this.state.userInEdit.mailingAddress1 === '' ? true : false}
            />
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="mailingAddress2">Address 2</label>
            <Input
              type="text"
              name="mailingAddress2"
              id="mailingAddress2"
              onChange={this.onDialogInputChange}
              value={this.state.userInEdit.mailingAddress2}
            />
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-6">
            <label htmlFor="mailingCity"
              className={this.props.touched.mailingCity && this.state.userInEdit.mailingCity === '' ? "error" : ""}
            >City</label>
            <Input
              type="city"
              name="mailingCity"
              id="mailingCity"
              onChange={this.onDialogInputChange}
              value={this.state.userInEdit.mailingCity}
              onBlur={this.handleBlur('mailingCity')}
              invalid={this.props.touched.mailingCity && this.state.userInEdit.mailingCity === '' ? true : false}
            />
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="state"
              className={this.props.touched.state && this.state.userInEdit.state === '' ? "error" : ""}
            >State</label>
            <DropDownList data={this.props.common.states}
              id="state"
              name="state"
              textField="name"
              dataItemKey="id"
              onChange={this.handleState}
              value={this.state.userInEdit.state}
              className={this.props.touched.state && this.state.userInEdit.state.name === '' ? "error" : ""}
              onBlur={this.handleBlur('state')}
            />
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="mailingZip"
              className={this.props.touched.mailingZip && this.state.userInEdit.mailingZip === '' ? "error" : ""}
            >Zip</label>
            <Input
              type="zip"
              name="mailingZip"
              id="mailingZip"
              pattern="(\d{5}([\-]\d{4})?)"
              placeholder="12345"
              title="Zip Code (Format: 12345)"
              value={this.state.userInEdit.mailingZip}
              onChange={this.handleZipChange}
              onBlur={this.handleBlur('mailingZip')}
              invalid={this.props.touched.mailingZip && this.state.userInEdit.mailingZip === '' ? true : false}
            />
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="phone"
              className={this.props.touched.phone && this.state.userInEdit.phone === '' ? "error" : ""}
            >Phone</label>
            <Input
              type="phone"
              name="phone"
              id="phone"
              pattern="[\(]\d{3}[\)] \d{3}[\-]\d{4}"
              title="Phone Number (Format: (123) 456-7890)"
              placeholder="(123) 456-7890"
              value={this.state.userInEdit.phone}
              onChange={this.handlePhoneChange}
              onBlur={this.handleBlur('phone')}
              invalid = {this.props.touched.phone && !this.state.userInEdit.phone && this.handlePhoneChange ? true : false}
            />
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-6">
            <label htmlFor="Email"
              className={this.props.touched.email && this.state.userInEdit.Email === '' ? "error" : ""}
            >Email</label>
            <Input
              type="email"
              name="Email"
              id="Email"
              value={this.state.userInEdit.Email}
              onChange={this.onDialogInputChange}
              onBlur={this.handleBlur('email')}
              invalid={this.props.touched.email && this.state.userInEdit.Email === '' ? true : false}
            />
          </div>
        </div>
      </div>
		);
	}
}
function mapStateToProps(state) {
    return {
        common: state.common,
        district: state.district,
        accountDetails: state.accountDetails
    }
}
export default withRouter(connect(mapStateToProps, {})(OrganizationInviteUser));
